var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bar__wrapper"},[(_setup.loading)?_c('div',{staticClass:"bar__loader"},[_c('q-spinner',{attrs:{"color":"primary","size":"3em"}})],1):_c(_setup.barChart,{attrs:{"chartData":_setup.chartData,"loading":_setup.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }